import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ variant = "dark", className = "" }) => {
  const ink = variant === "light" ? "#FBFBF9" : "#1A1C1A";
  const brand = "#0F7A3E";
  return (
    <Link
      to="/"
      data-testid="site-logo-link"
      className={`flex items-center gap-3 group ${className}`}
      aria-label="Saafi Industries — home"
    >
      <span className="relative inline-flex items-center justify-center">
        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" aria-hidden="true">
          <rect x="1" y="1" width="38" height="38" stroke={ink} strokeWidth="1.5" />
          <path
            d="M12 26C14 22 17 20 20 20C23 20 26 18 28 14"
            stroke={brand}
            strokeWidth="1.75"
            strokeLinecap="round"
          />
          <circle cx="28" cy="14" r="2" fill={brand} />
          <circle cx="12" cy="26" r="2" fill={ink} />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span
          className="font-display tracking-tight text-[17px] font-medium"
          style={{ color: ink }}
        >
          Saafi Industries
        </span>
        <span
          className="text-[10px] uppercase tracking-[0.25em] mt-1"
          style={{ color: variant === "light" ? "#9FA498" : "#575B57" }}
        >
          Advisory · Investment · Execution
        </span>
      </span>
    </Link>
  );
};

export default Logo;
